import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_download.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2acd090c")

_pushScopeId("data-v-2acd090c")
const _hoisted_1 = {
  key: 0,
  class: "border border-gray-lp-1300 bg-white py-1 w-full rounded-lg",
  style: {"height":"fit-content","margin-top":"22px"}
}
const _hoisted_2 = { class: "flex flex-row items-center justify-between px-3" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "download-icon"
}, null, -1)
const _hoisted_5 = { class: "text-red-lp-100 font-bold whitespace-nowrap break-all" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.data.length)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.title) + " " + _toDisplayString(_ctx.isDispatch ? "" : `(${_ctx.data.length})`), 1),
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args))),
            onEnter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args)))
          }, [
            _hoisted_4
          ], 32)
        ]),
        _createVNode("div", {
          class: "overflow-y-auto flex flex-col divide-y divide-gray-lp-1400 pl-3 pr-1.5 cargo-scan-failed-card",
          style: { maxHeight: _ctx.isDispatch ? '150px' : '63px' }
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "flex flex-col py-2"
            }, [
              _createVNode("div", {
                class: `flex gap-x-4 ${_ctx.dataDirection} overflow-hidden`
              }, [
                _createVNode("div", _hoisted_5, _toDisplayString(item.sttNumber), 1),
                _createVNode("div", {
                  class: "text-gray-lp-300 text-xs whitespace-nowrap overflow-ellipsis overflow-hidden",
                  title: item.failureReason
                }, _toDisplayString(item.failureReason), 9, ["title"])
              ], 2)
            ]))
          }), 128))
        ], 4)
      ]))
    : _createCommentVNode("", true)
})